import React, { useState, useEffect } from 'react';
import api from '../api/axios';

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await api.get('/users/all');
      setUsers(res.data.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const handleRoleChange = async (userId, newRole) => {
    try {
      await api.put('/users/role', { userId, role: newRole });
      // Update local state
      setUsers(users.map(u => u._id === userId ? { ...u, role: newRole } : u));
      alert('User role updated successfully');
    } catch (err) {
      console.error(err);
      alert('Failed to update user role');
    }
  };

  if (loading) return (
    <div className="flex justify-center py-20">
      <div className="w-12 h-12 border-4 border-[#2A2858]/20 border-t-[#2A2858] rounded-full animate-spin"></div>
    </div>
  );

  return (
    <div className="p-8 font-sans">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h2 className="font-serif text-3xl font-bold text-[#2A2858]">Registered Users</h2>
          <p className="mt-1 text-stone-500 text-sm">Manage user accounts and platform permissions</p>
        </div>
      </div>

      <div className="bg-white border border-[#E8B84B]/20 rounded-2xl overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-[#FAF9F6] border-b border-[#E8B84B]/20 text-xs">
              <th className="px-8 py-4 font-bold text-[#2A2858] uppercase tracking-widest">Name</th>
              <th className="px-8 py-4 font-bold text-[#2A2858] uppercase tracking-widest">Email</th>
              <th className="px-8 py-4 font-bold text-[#2A2858] uppercase tracking-widest">Joined Date</th>
              <th className="px-8 py-4 font-bold text-[#2A2858] uppercase tracking-widest">Role</th>
              <th className="px-8 py-4 font-bold text-[#2A2858] uppercase tracking-widest text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-stone-50">
            {users.map((user) => (
              <tr key={user._id} className="hover:bg-stone-50 transition-colors">
                <td className="px-8 py-5 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#2A2858]/10 text-[#2A2858] flex items-center justify-center text-sm font-bold border border-[#2A2858]/5">
                    {user.name.charAt(0)}
                  </div>
                  <span className="font-bold text-stone-800">{user.name}</span>
                </td>
                <td className="px-8 py-5 text-stone-500 text-sm font-medium">{user.email}</td>
                <td className="px-8 py-5 text-stone-500 text-sm">
                  {new Date(user.createdAt).toLocaleDateString([], { day: 'numeric', month: 'short', year: 'numeric' })}
                </td>
                <td className="px-8 py-5">
                  <span className={`px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border ${
                    user.role === 'ADMIN' ? 'bg-red-50 text-red-700 border-red-200' :
                    user.role === 'VENDOR' ? 'bg-orange-50 text-orange-700 border-orange-200' :
                    user.role === 'ACARYA' ? 'bg-purple-50 text-purple-700 border-purple-200' :
                    'bg-blue-50 text-blue-700 border-blue-200'
                  }`}>
                    {user.role}
                  </span>
                </td>
                <td className="px-8 py-5 text-right">
                   <select 
                      value={user.role} 
                      onChange={(e) => handleRoleChange(user._id, e.target.value)}
                      className="bg-stone-50 border border-stone-200 rounded-lg px-3 py-1.5 text-xs font-bold outline-none focus:border-[#E8B84B] transition-all"
                   >
                      <option value="USER">Devotee (USER)</option>
                      <option value="VENDOR">Vendor</option>
                      <option value="ACARYA">Acarya (ACARYA)</option>
                      <option value="ADMIN">Admin</option>
                   </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {users.length === 0 && (
           <div className="p-20 text-center text-stone-300 font-bold uppercase tracking-widest">
              No users found in records
           </div>
        )}
      </div>
    </div>
  );
};

export default Users;